import { faTrashCan } from "@fortawesome/pro-light-svg-icons"

import {
  GenericButton,
  TextLarge,
  TextNormal,
} from "@finanedi.es/front/common/atoms"

import { ILeyAntifraudeFormRepresentantesFormTemplateFieldsParams } from "../interfaces"

export const leyAntifraudeFormRepresentantesFormTemplateFields = ({
  fields,
  onRemoveRepresentante,
}: ILeyAntifraudeFormRepresentantesFormTemplateFieldsParams) => {
  const empresaFields = () => {
    return [
      {
        type: "text",
        name: "empresa_nif",
        label: "NIF",
        disabled: true,
        className: "fs-col-span-12",
        labelClassName: "fs-text-sm",
      },
      {
        type: "text",
        name: "empresa_razonSocial",
        label: "Razón social",
        disabled: true,
        className: "fs-col-span-12",
        labelClassName: "fs-text-sm",
      },
      {
        type: "text",
        name: "empresa_calle",
        label: "Calle",
        placeholder: "Ej: Calle Principal",
        className: "fs-col-span-12 tablet:fs-col-span-8",
        labelClassName: "fs-text-sm",
      },
      {
        type: "text",
        name: "empresa_numero",
        label: "Número",
        placeholder: "Ej: 1",
        className: "fs-col-span-12 tablet:fs-col-span-4",
        labelClassName: "fs-text-sm",
      },
      {
        type: "text",
        name: "empresa_municipio",
        label: "Municipio",
        placeholder: "Ej: Madrid",
        className: "fs-col-span-12",
        labelClassName: "fs-text-sm",
      },
    ]
  }

  const representantesFields = (index: number) => {
    return [
      {
        type: "text",
        name: `representantes.${index}.nombreCompleto`,
        label: "Nombre completo del representante",
        placeholder: "Ej: Juan Pérez",
        className: "fs-col-span-12",
        labelClassName: "fs-text-sm",
      },
      {
        type: "text",
        name: `representantes.${index}.nif`,
        label: "NIF del representante",
        placeholder: "Ej: 12345678Z",
        className: "fs-col-span-12",
        labelClassName: "fs-text-sm",
      },
      {
        type: "text",
        name: `representantes.${index}.calle`,
        label: "Calle",
        placeholder: "Ej: Calle Principal",
        className: "fs-col-span-12 tablet:fs-col-span-8",
        labelClassName: "fs-text-sm",
      },
      {
        type: "text",
        name: `representantes.${index}.numero`,
        label: "Número",
        placeholder: "Ej: 1",
        className: "fs-col-span-12 tablet:fs-col-span-4",
        labelClassName: "fs-text-sm",
      },
      {
        type: "text",
        name: `representantes.${index}.municipio`,
        label: "Municipio",
        placeholder: "Ej: Madrid",
        className: "fs-col-span-12",
        labelClassName: "fs-text-sm",
      },
    ]
  }

  return [
    {
      type: "template",
      template: (
        <div className='fs-col-span-12'>
          <TextLarge
            className='fs-text-sm fs-font-medium'
            text='Datos de la empresa'
          />
        </div>
      ),
    },
    {
      group: "empresa",
      containerClassName: "fs-flex fs-flex-col fs-gap-3 fs-col-span-12",
      groupClassName:
        "fs-grid fs-grid-cols-12 fs-gap-3 fs-p-2 1k:fs-p-4 fs-rounded-lg fs-bg-gray-50 fs-border fs-border-solid fs-border-gray-200",
      fields: empresaFields(),
    },
    ...fields.flatMap((field, index) => [
      {
        type: "template",
        template: (
          <div className='fs-col-span-12 fs-text-sm fs-font-medium'>
            <TextLarge
              className='fs-text-sm fs-font-medium'
              text='Datos de los representantes legales'
            />
          </div>
        ),
      },
      {
        group: `representante-${field.id}`,
        containerClassName: "fs-flex fs-flex-col fs-gap-3 fs-col-span-12",
        groupClassName:
          "fs-grid fs-grid-cols-12 fs-gap-3 fs-p-2 1k:fs-p-4 fs-rounded-lg fs-bg-gray-50 fs-border fs-border-solid fs-border-gray-200",
        fields: [
          {
            type: "template",
            template: fields.length > 1 && (
              <div className='fs-col-span-12 fs-flex fs-items-center fs-justify-between'>
                <TextNormal text={`Representante ${index + 1}`} />
                <GenericButton
                  buttonType='none'
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  icon={faTrashCan as any}
                  className='fs-text-danger'
                  onClick={() => onRemoveRepresentante(index)}
                />
              </div>
            ),
          },
          ...representantesFields(index),
        ],
      },
    ]),
  ]
}
